import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';

import { ADMINS_JOB_STATUS_PATH } from '../../utils/constants';
import { JobStatusList } from './components/JobStatusList/JobStatusList';
import React from 'react';

export const JobStatus = () => {
  return (
    <Switch path={ADMINS_JOB_STATUS_PATH}>
      <Route exact path={ADMINS_JOB_STATUS_PATH} component={JobStatusList} />
    </Switch>
  );
};
